module.exports = {
      id: "ios-small-usage",
      viewBox: "0 0 448 512",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#ios-small",
      toString: function () {
        return this.url;
      }
    }